import React, { useState, useCallback } from 'react';
import { Field } from '../../../headless/field';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicTextInputProps } from '../../../types/public-props';

interface InputTextInputProps {
  className?: string;
}

export const Input = React.forwardRef<HTMLDivElement, InputTextInputProps>(
  (props, ref) => {
    const { className } = props;
    const {
      placeholder,
      value: defaultValue,
      onChange,
      onBlur,
      readOnly,
      minLength,
      maxLength,
    } = useFieldProps<PublicTextInputProps>();

    const [value, setValue] = useState(defaultValue || '');

    const handleChange = useCallback(
      (text: string) => {
        onChange(text);
        setValue(text);
      },
      [onChange, setValue],
    );

    return (
      <Field.Input ref={ref}>
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          readOnly={readOnly}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={onBlur}
          className={className}
          minLength={minLength}
          maxLength={maxLength}
        />
      </Field.Input>
    );
  },
);

Input.displayName = 'TextInput.Input';
